"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _popupConfig = require("@/api/popup/popupConfig.js");
var _decorateConfig = require("@/api/decorate/decorateConfig.js");
var _memberManagement = require("@/api/member/memberManagement.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CommunityHomepageIcon',
  props: {
    pageKey: {
      type: String,
      default: ''
    },
    moduleKey: {
      type: String,
      default: ''
    },
    xcxType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      imagePrefix: '',
      id: null,
      // 预览弹窗相关
      previewVisible: false,
      previewImageUrl: '',
      // 节日日期范围
      holidayDateRange: [],
      // 日常场景数据
      dailyData: [{
        label: 'n'
      }, {
        label: 'y'
      }],
      // 会员日场景数据
      memberData: [{
        label: 'n'
      }, {
        label: 'y'
      }],
      // 节日场景数据
      holidayData: [{
        label: 'n'
      }, {
        label: 'y'
      }],
      // 内容数据存储
      contentData: {
        daily: {
          n: {
            home: '',
            discover: '',
            member: '',
            order: '',
            profile: ''
          },
          y: {
            home: '',
            discover: '',
            member: '',
            order: '',
            profile: ''
          }
        },
        member: {
          n: {
            home: '',
            discover: '',
            member: '',
            order: '',
            profile: ''
          },
          y: {
            home: '',
            discover: '',
            member: '',
            order: '',
            profile: ''
          }
        },
        holiday: {
          n: {
            home: '',
            discover: '',
            member: '',
            order: '',
            profile: ''
          },
          y: {
            home: '',
            discover: '',
            member: '',
            order: '',
            profile: ''
          }
        }
      }
    };
  },
  created: function created() {
    // 组件创建时可以访问到传入的key值
    console.log('CommunityHomepageIcon - pageKey:', this.pageKey, 'moduleKey:', this.moduleKey);
    // 获取图片前缀
    this.getImagePrefix();
    // 页面加载时获取已保存的配置
    this.loadConfig();
  },
  methods: {
    // 确认保存
    confirmSave: function confirmSave() {
      var _this = this;
      this.$confirm('保存后将替换正在使用的配置，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 用户点击确定，执行保存操作
        _this.handleSave();
      }).catch(function () {
        // 用户点击取消，不执行任何操作
        _this.$message.info('已取消保存');
      });
    },
    // 获取图片前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取图片前缀失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 获取图片完整URL
    getImageUrl: function getImageUrl(url) {
      // 如果没有url则返回空
      if (!url) return '';

      // 如果已经是完整URL则直接返回
      if (url.startsWith('http')) {
        return url;
      }

      // 如果有图片前缀，使用图片前缀
      if (this.imagePrefix) {
        // 确保前缀末尾没有斜杠，url开头有斜杠
        var prefix = this.imagePrefix.endsWith('/') ? this.imagePrefix.slice(0, -1) : this.imagePrefix;
        var path = url.startsWith('/') ? url : '/' + url;
        return prefix + path;
      }

      // 如果是相对路径，则加上基础URL
      return process.env.VUE_APP_BASE_API + url;
    },
    // 上传前检查
    beforeUpload: function beforeUpload(file) {
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    // 自定义上传方法，调用uploadPopupImage接口
    customUpload: function customUpload(options, scenario, page, rowLabel) {
      var _this2 = this;
      // 显示上传loading
      var loading = this.$loading({
        lock: true,
        text: '图片上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 调用uploadPopupImage接口上传图片
      (0, _popupConfig.uploadPopupImage)(options.file).then(function (response) {
        loading.close();
        if (response.code === 200 && response.data) {
          // 上传成功，更新对应场景的图标URL
          _this2.contentData[scenario][rowLabel][page] = response.data;
          _this2.$message.success('图片上传成功');
        } else {
          _this2.$message.error(response.message || '图片上传失败');
        }
      }).catch(function (error) {
        loading.close();
        console.error('图片上传失败:', error);
        _this2.$message.error('图片上传失败: ' + (error.message || '未知错误'));
      });
    },
    // 处理内容上传成功
    handleContentSuccess: function handleContentSuccess(response, file, scenario, page, rowLabel) {
      var url = URL.createObjectURL(file.raw);
      this.contentData[scenario][rowLabel][page] = url;
    },
    // 获取内容图片
    getContentImage: function getContentImage(scenario, page, rowLabel) {
      return this.getImageUrl(this.contentData[scenario][rowLabel][page]);
    },
    // 保存配置
    handleSave: function () {
      var _handleSave = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var config, data, _loading, response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              config = {
                daily: this.contentData.daily,
                member: this.contentData.member,
                holiday: {
                  dateRange: this.holidayDateRange,
                  data: this.contentData.holiday
                }
              };
              data = {
                id: this.id,
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                configInfo: JSON.stringify(config)
              }; // 显示保存loading状态
              _loading = this.$loading({
                lock: true,
                text: '保存中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口保存配置
              _context2.next = 1;
              return (0, _decorateConfig.saveDecorateConfig)(data);
            case 1:
              response = _context2.sent;
              // 关闭loading
              _loading.close();
              if (response.code === 200) {
                this.$message.success('配置保存成功');
              } else {
                this.$message.error(response.message || '保存失败!');
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('保存失败:', _t2);
              this.$message.error('保存失败: ' + (_t2.message || '未知错误'));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function handleSave() {
        return _handleSave.apply(this, arguments);
      }
      return handleSave;
    }(),
    // 预览配置
    handlePreview: function () {
      var _handlePreview = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var config, configInfo, _loading2, response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              config = {
                daily: this.contentData.daily,
                member: this.contentData.member,
                holiday: {
                  dateRange: this.holidayDateRange,
                  data: this.contentData.holiday
                }
              }; // 将配置转换为JSON字符串
              configInfo = {
                id: this.id,
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                previewConfigInfo: JSON.stringify(config)
              }; // 显示预览loading状态
              _loading2 = this.$loading({
                lock: true,
                text: '预览中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口预览配置
              _context3.next = 1;
              return (0, _decorateConfig.previewDecorateConfigInfo)(configInfo, this.xcxType);
            case 1:
              response = _context3.sent;
              // 关闭loading
              _loading2.close();
              if (response.code === 200) {
                // 预览成功，显示返回的图片
                if (response.data) {
                  // 检查是否有图片URL直接返回
                  if (response.data.image && typeof response.data.image === 'string') {
                    // 如果返回了图片URL，显示预览弹窗
                    this.previewImageUrl = response.data.image;
                    this.previewVisible = true;
                  } else {
                    this.$message.success('社区首页图标配置预览成功');
                  }
                } else {
                  this.$message.success('社区首页图标配置预览成功');
                }
              } else {
                this.$message.error(response.message || '预览失败!');
              }
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('预览失败:', _t3);
              this.$message.error('预览失败: ' + (_t3.message || '未知错误'));
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function handlePreview() {
        return _handlePreview.apply(this, arguments);
      }
      return handlePreview;
    }(),
    // 应用配置
    handleApply: function handleApply() {
      var config = {
        daily: this.contentData.daily,
        member: this.contentData.member,
        holiday: {
          dateRange: this.holidayDateRange,
          data: this.contentData.holiday
        }
      };
      console.log('应用配置:', config);
      this.$message.success('配置应用成功');
    },
    // 处理预览弹窗关闭
    handlePreviewClose: function handlePreviewClose() {
      this.previewVisible = false;
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    },
    // 组件销毁前释放资源
    beforeDestroy: function beforeDestroy() {
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    },
    // 加载配置
    loadConfig: function () {
      var _loadConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _loading3, response, configInfo, parsedConfig, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              if (!(!this.pageKey || !this.moduleKey)) {
                _context4.next = 1;
                break;
              }
              return _context4.abrupt("return");
            case 1:
              // 显示加载loading状态
              _loading3 = this.$loading({
                lock: true,
                text: '加载配置中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口获取配置
              _context4.next = 2;
              return (0, _decorateConfig.getDecorateConfig)(this.pageKey, this.moduleKey);
            case 2:
              response = _context4.sent;
              // 关闭loading
              _loading3.close();
              if (response.code === 200 && response.data) {
                // 保存ID
                this.id = response.data.id;

                // 解析配置信息
                configInfo = response.data.configInfo;
                if (configInfo) {
                  // 将JSON字符串转换为对象
                  parsedConfig = typeof configInfo === 'string' ? JSON.parse(configInfo) : configInfo; // 更新各场景数据
                  if (parsedConfig.daily) {
                    this.contentData.daily = parsedConfig.daily;
                  }
                  if (parsedConfig.member) {
                    this.contentData.member = parsedConfig.member;
                  }
                  if (parsedConfig.holiday) {
                    this.holidayDateRange = parsedConfig.holiday.dateRange || [];
                    this.contentData.holiday = parsedConfig.holiday.data || this.contentData.holiday;
                  }
                }
              } else if (response.code !== 200) {
                this.$message.error(response.message || '配置加载失败!');
              }
              // 如果response.data为空，说明还没有保存过配置，使用默认值
              _context4.next = 4;
              break;
            case 3:
              _context4.prev = 3;
              _t4 = _context4["catch"](0);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('配置加载失败:', _t4);
              this.$message.error('配置加载失败: ' + (_t4.message || '未知错误'));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 3]]);
      }));
      function loadConfig() {
        return _loadConfig.apply(this, arguments);
      }
      return loadConfig;
    }()
  }
};